import { Controller } from 'stimulus';
import Cookies from 'js-cookie';
import events from 'lib/events';
import { triggerCustomEvent } from 'lib/helpers';
// import { delegate } from 'ez-styles/assets/javascripts/ez-styles/utils/helpers';
import SSTKAPI from '../../shutterstock-api';
import sendSSTKClickEvent from '../../shutterstock-analytics-listener';

export default class SSTKSponsoredSearchController extends Controller {
  static targets = [
    'apiResultsWrapper',
    'couponCodeLink',
    'term',
    'page',
  ];

  connect() {
    this.searchTerm = this.termTarget.value;

    this.sstkSharedId = this.element.getAttribute('data-sstk-sharedid');
    this.sstkSubId1 = this.element.getAttribute('data-subid-one');
    this.mobileTag = document.body.classList.contains('is-mobile') ? '|mobile' : '';

    this.element.addEventListener('click', sendSSTKClickEvent, { once: false });

    this.getSSTKResults();

    const noResultTimer = setTimeout(() => {
      triggerCustomEvent(events.sponsored_search.without_results, { searchTerm: this.searchTerm });

      if (!this.element.querySelector('.ez-resource-thumb')) {
        this.element.parentNode.removeChild(this.element);
      }
    }, this.noResultsDelay);

    // TODO: Set up tracking here
    // delegate(document, 'click', '[data-target="sstk-sponsored-search.apiResultsWrapper"] li a', () => {
    //   track('click', this.searchTerm, 'shutterstock');
    // });

    window.addEventListener('resultsLoaded', (event) => {
      if (event.detail !== 'END_OF_RESULTS') {
        window.clearTimeout(noResultTimer);
      }
    });

    triggerCustomEvent(events.sponsored_search.position, {
      searchTerm: this.searchTerm,
      position: this.position,
    });
  }

  disconnect() {
    this.element.removeEventListener('click', sendSSTKClickEvent, { once: false });
  }

  get noResultsDelay() {
    return 15 * 1000;
  }

  get position() {
    switch (this.sstkSubId1) {
      case 'search-top':
        return 'top';
      case 'search-bottom':
        return 'bottom';
      default:
        return this.sstkSubId1;
    }
  }

  revealPromoCode(event) {
    event.preventDefault();

    this.makeCouponWindow();

    window.location = this.makeSSTKUrl();
  }

  makeSSTKUrl() {
    return `http://shutterstock.7eer.net/c/38919/145264/1305?sharedid=${this.sstkSharedId}`
            + '&subId1=coupon'
            + `&subId2=${encodeURI(this.searchTerm)}`
            + `&subId3=${Cookies.get('ga-client-id')}${this.mobileTag}`;
  }

  makeCouponWindow() {
    const win = window.open('', 'shutterstock-sale', 'width=520,height=320');

    win.location.href = '/sstk/coupon_code';
  }

  getSSTKResults() {
    const sstk = new SSTKAPI(this.apiResultsWrapperTarget, this.searchTerm);

    sstk.getResults({
      controllerElem: this.element,
      page: this.pageTarget.value,
      affiliate: this.apiResultsWrapperTarget.getAttribute('data-affiliate'),
      apiparams: this.apiResultsWrapperTarget.getAttribute('data-apiparams'),
      ird: this.apiResultsWrapperTarget.getAttribute('data-ird'),
      limit: this.apiResultsWrapperTarget.getAttribute('data-limit'),
      loc: this.apiResultsWrapperTarget.getAttribute('data-loc'),
      rowHeight: 70,
      maxRows: this.apiResultsWrapperTarget.getAttribute('data-max-rows'),
      urlparams: sstk.makeUrlParams(this.sstkSharedId, this.sstkSubId1, this.searchTerm),
    });
  }
}
